$(document).ready(function(){
	// Request a Repair : Attach Documents
	if(!document.getElementById('step_attach_documents')) return false;

	// step 3 form
	var form = {
		$el: $('#attachDocumentsForm'),
		$file: null,
		initialFormValue: null,
		$submitBtn: null,
		init: function(){
			form.$file = form.$el.find("[id^=file]");
			form.$file.length && form.$file.fileUploadSet();

			form.$submitBtn = this.$el.find('.field-btn-area button');

			form.setInitialFormValue();
			this.addEvent();
		},
		setInitialFormValue: function(){
			var $elWrap = form.$el;
			var $el = $elWrap.find("input:not([type='image']), select, textarea").not(".chosen-search-input");
			var initialFormValue = {};
			$el.each(function(){
				var $this = $(this);
				var id = $this.prop("id");
				var name = $this.attr("name");
				var tagName = $this.prop("tagName");
				initialFormValue[tagName+"-"+name+"-"+id] = {
					value: $this.val(),
					required: $this.prop("required") ? ($this.get(0).getAttribute("required") !== "false" ? true : null) : null,
					disabled: $this.prop("disabled") || null,
					readonly: $this.prop("readonly") || null,
					checked: $this.prop("checked") || null
				}
			})
			form.initialFormValue = initialFormValue;
		},
		resetFormValue: function($elWrap){
			// file upload delete btn hidden, not first child remove
			form.$el.find("#file .field-block").first().find(".delivery-part").removeClass("attached");
			form.$el.find("#file .field-block").not(":first").remove();
			
			var $elWrap = $elWrap || form.$el;
			var $el = $elWrap.find("input:not([type='image']), select, textarea").not(".chosen-search-input");
			
			if(!form.initialFormValue || !$el.length){ return };

			$el.each(function(){
				var $this = $(this);
				var id = $this.prop("id");
				var name = $this.attr("name");
				var tagName = $this.prop("tagName");
				if(form.initialFormValue.hasOwnProperty(tagName+"-"+name+"-"+id)) { // 초기값이 있는 경우
					var prop = form.initialFormValue[tagName+"-"+name+"-"+id];
					if($this.attr("type") !== "radio") $this.val(prop["value"]);
					prop["required"] ? $this.attr("required", "required") : $this.removeAttr("required");
					prop["disabled"] ? $this.attr("disabled", "disabled") : $this.removeAttr("disabled");
					prop["readonly"] ? $this.attr("readonly", "readonly") : $this.removeAttr("readonly");
					prop["checked"] ? $this.prop("checked",true) : $this.prop("checked",false);
				}else{ // 초기값이 없는 경우
					$this.val("");
					$this.prop("checked",false);
				}
				$this.removeAttr("aria-describedby").parents(".field-block").first().removeClass("error").find(".error-msg > span").hide(); // error remove
				$this.hasClass("run-chosen") && $this.trigger('chosen:updated'); // select chosen update
			});
		},
		beforeSubmit: function(){
			// whole form validation;
			if(this.$el.checkValidation({trigger:true})) {
				form.$el.trigger('submit:confirmed');
			}
		},
		addEvent: function(){
			form.$el.on({
				"attachDocuments:reset": function(e){
					e.preventDefault();
					form.resetFormValue();
				}
			})

			// Submit 버튼 click 이벤트
			this.$submitBtn.on({
				click: function(e){
					e.preventDefault();
					form.beforeSubmit();
					return false;
				}
			});
		},
	}

	form.init(); // whole form

});